<template>
  <div class="user-transfet-page">
    <div class="title t-c">
      <div class="left">
        <!-- <i class="icon el-icon-data-analysis"></i> -->
        <img class="icon" src="@/assets/images/icon_mask_user.png" />
        <p class="txt">{{$vi18n('$i18n# 账号管理 #i18n$')}}</p>
      </div>
      <div>
        <!-- <i class="icon el-icon-s-finance"></i> -->
        <img class="icon" src="@/assets/images/icon_mask_money.png" />
        <p class="txt">{{$vi18n('$i18n# 收益查询 #i18n$')}}</p>
      </div>
    </div>
    <div class="desc t-c">
      <p>{{$vi18n('$i18n# 成为迷你世界创作者，在创作者中心查看更多作品数据。 #i18n$')}}</p>
      <p>{{$vi18n('$i18n# 快去创作地图投稿吧！成为迷你世界见习创作者！ #i18n$')}}</p>
    </div>
    <!-- <div class="mt20"><el-button @click="dialogValue = true" type="primary">{{$vi18n('$i18n# 数据分析 #i18n$')}}去投稿</el-button></div> -->
    <!-- <el-dialog
      :visible.sync="dialogValue"
      width="500px"
      class="level-desc-dialog"
    >
    <div class="t-c">
      <p>成为迷你世界创作者，在创作者中心查看更多作品数据。</p>
      <p>快去创作地图投稿吧！成为迷你世界见习创作者！</p>
      <el-button class="mt20" size="small" @click="dialogValue = false" type="primary">关闭</el-button>
    </div>
    </el-dialog> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      // dialogValue: false,
    }
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.t-c {
  text-align: center;

}
.user-transfet-page {
  height: 1000px;
  background-color: white;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .title {
    display: flex;
    color: #999999;
    .left {
      margin-right: 100px;
    }
    .icon {
      font-size: 70px;
    }
    .txt {
      margin-top: 15px;
      font-size: 30px;
    }
  }
  .desc {
    margin-top: 40px;
    font-size: 24px;
    margin-bottom: 20px;
  }
  .mt20 {
    margin-top: 20px;
  }
}
</style>